export default __webpack_public_path__ + "static/media/universe.ca8d37a9.png";